import { render, staticRenderFns } from "./BantuanRegister.vue?vue&type=template&id=62c677ae&scoped=true&"
import script from "./BantuanRegister.vue?vue&type=script&lang=js&"
export * from "./BantuanRegister.vue?vue&type=script&lang=js&"
import style0 from "./BantuanRegister.vue?vue&type=style&index=0&id=62c677ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c677ae",
  null
  
)

export default component.exports